export const { REACT_APP_ASSET_STORAGE_DOMAIN, REACT_APP_API_END_POINT } = process.env
